import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { Regular, TertiaryButton, useModal, ZazumeModal } from '@zazume/zzm-base';

import { useI18n } from '../../../hooks/useI18n';
import { useNotifications } from '../../../hooks/useNotifications';

const Body = styled.div(
  ({ theme }) => css`
    padding: 0 0 ${theme.spacing.s8} 0;
    min-height: 4.375rem;
  `
);

const Footer = styled.div(
  ({ theme }) => css`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: ${theme.spacing.s10};
  `
);

export const ErrorModal = ({ id, message, canDismiss = true }) => {
  const { t } = useI18n();
  const { closeNotification } = useNotifications();

  const { RenderModal, close } = useModal({
    isOpen: true,
    modalSize: 's',
    alert: true,
    withMobileFullscreen: false,
    isDismissable: canDismiss
  });

  const handleOnClose = () => {
    close();
    closeNotification(id);
  };

  return (
    <RenderModal>
      <ZazumeModal
        title={t('general.errorOcurred')}
        onClose={handleOnClose}
        leftIcon="cross"
        withCloseButton={canDismiss}
        circleIcon
      >
        <Body>
          <Regular color="Gray500" variant="S">
            {message}
          </Regular>
        </Body>
        {canDismiss && (
          <Footer>
            <TertiaryButton size="Large" onClick={handleOnClose}>
              {t('buttons.accept')}
            </TertiaryButton>
          </Footer>
        )}
      </ZazumeModal>
    </RenderModal>
  );
};
